
import Vue from 'vue'

import {get} from 'lodash-es'

Vue.prototype.$get = get
